import { dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType } from "dmpconnectjsapp-base/actions";
import commands                                                                     from "dmpconnectjsapp-base/actions/config/commands";
import { apiSections }                                                              from "dmpconnectjsapp-base/constants";
import moment                                                                       from "moment";
import { put, select, take }                  from "redux-saga/effects";
import { getAction, handleSetPersistantData } from "../actions";
import { objectWithoutTheseKeys }             from "../utils/dataUtils";

export function * setPersistantData ({data, reason, callId}) {
  
  yield put(getAction(
    commands.setPersistantData,
    apiSections.SET_PERSISTANT_DATA,
    data,
    {
      synchronous : true,
      contextExtra: { reason, callId }
    }
  ));
  
  let result;
  while (!result) {
    const setPersistantDataResult = yield take(
      [
        dmpCommandSuccessContextualizedType(apiSections.SET_PERSISTANT_DATA),
        dmpCommandFailureContextualizedType(apiSections.SET_PERSISTANT_DATA)
      ]
    );
    
    const { context: { callId: resultCallId } } = setPersistantDataResult;
    if (resultCallId === callId) {
      result = setPersistantDataResult;
    }
  }
  
  return result;
}

export const getLocalPersistantData = (state) => {
  const { persistantData } = state;
  return objectWithoutTheseKeys(persistantData, ["_persist"]);
};

export function * saveStatInPersistantData (action) {
  const currentData = yield select(getLocalPersistantData);
  let alim;
  let consult;
  let startDate;
  let persistantDataRest;
  let efficienceDataRest;
  try {
    
    const {
            efficience: {
              statistics: {
                alim     : persistedAlim      = 0,
                consult  : persistedConsult   = 0,
                startDate: persistedStartDate = moment().format("YYYYMMDD")
              } = {},
              ...efficienceData
            } = {},
            ...persistantData
          } = currentData;
    
    alim               = persistedAlim;
    consult            = persistedConsult;
    startDate          = persistedStartDate;
    persistantDataRest = persistantData;
    efficienceDataRest = efficienceData;
  } catch (e) {
    alim               = 0;
    consult            = 0;
    startDate          = moment().format("YYYYMMDD");
    persistantDataRest = null;
    efficienceDataRest = null;
  }
  yield put(handleSetPersistantData({
    ...persistantDataRest,
    efficience: {
      statistics: {
        alim   : action.type === dmpCommandSuccessContextualizedType(apiSections.SEND_DOCUMENT_SECTION) ? alim + 1 : alim,
        consult: action.type === dmpCommandSuccessContextualizedType(apiSections.DOCUMENT_CONTENT_SECTION) ? consult + 1 : consult,
        startDate
      },
      ...efficienceDataRest
    }
  }));
}
